var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{attrs:{"items":_vm.items,"hide-details":_vm.hideDetails,"single-line":_vm.singleLine,"label":_vm.label,"dense":_vm.dense},on:{"change":_vm.change},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }